import React from "react";
import { useLatest } from "react-use";
export const useRunWithFlag = () => {
    const [flag, setFlag] = React.useState(false);
    const flagRef = useLatest(flag);
    const runWithFlag = React.useCallback(async (fn) => {
        // prevent overrun
        if (flagRef.current)
            return;
        setFlag(true);
        let error;
        try {
            return await fn();
        }
        catch (e) {
            error = e;
        }
        finally {
            setFlag(false);
        }
        if (error)
            throw error;
    }, [flagRef]);
    return [flag, runWithFlag];
};
//# sourceMappingURL=useRunWithFlag.js.map